/**
 * Completely random generation of unique strings
 * @param {Number} size Generate the length of a random string
 * @default 10
 * @returns {String} Randomly generated string
 */
function unique(size) {
  size = size || 10;

  var r = function r() {
    return Math.random().toString(36).slice(2);
  };

  var result = r();

  while (result.length < size) {
    result += r();
  }

  return result.slice(0, size);
}

/**
 * is Element
 * @param {*} el value
 * @returns {Boolean}
 */
function isElement(el) {
  return el instanceof Element;
}
/**
 * is String
 * @param {*} val value
 * @returns {Boolean}
 */

function isString(val) {
  return typeof val === 'string';
}
/**
 * Creating element
 * @param {String} name Element Name
 * @param {String} className Element className
 * @returns {HTMLElement}
 */

function createElement(name, className) {
  var dom = document.createElement(name);
  if (className) dom.className = className;
  return dom;
}
/**
 * Creates svg element
 * @param {String} name Element Name
 * @param {Object} obj Objects of key-value pairs
 * @returns {SVGElement}
 */

function createSVG(name, obj) {
  var el = document.createElementNS('http://www.w3.org/2000/svg', name);

  for (var key in obj) {
    el.setAttribute(key, obj[key]);
  }

  return el;
}
/**
 * Creates close SVG
 * @returns {SVGElement} closeSVG
 */

function createCloseSVG() {
  var closeSVG = createSVG('svg', {
    width: '16px',
    height: '16px',
    stroke: 'currentColor',
    viewBox: '0 0 16 16',
    'stroke-linecap': 'round'
  });
  var line1 = createSVG('line', {
    x1: -7,
    y1: -7,
    x2: 6,
    y2: 6,
    transform: 'translate(8.5 8.5)'
  });
  var line2 = createSVG('line', {
    x1: 6,
    y1: -7,
    x2: -7,
    y2: 6,
    transform: 'translate(8.5 8.5)'
  });
  closeSVG.appendChild(line1);
  closeSVG.appendChild(line2);
  return closeSVG;
}
/**
 * Set the position of the message
 * @param {Array} instances All instances of message
 * @param {Element} startIndex Start index to begin traversal
 */

function setPosition(instances) {
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (startIndex < -1) return;
  var prevOffset = 0;

  for (var i = startIndex; i < instances.length; i++) {
    var el = instances[i];
    if (!el) continue;
    var prev = instances[i - 1];

    if (prev) {
      prevOffset = parseInt(prev.style.top) + parseInt(prev.offsetHeight);
    }

    el.style.zIndex = el._msg.zIndex + i;
    el.style.top = el._msg.offset + prevOffset + 'px';
  }
}

var styles = "._msg{left:50%;color:#909399;font-size:14px;width:300px;padding:16px 17px;position:fixed;line-height:1;letter-spacing:1px;word-wrap:break-word;word-break:break-all;border-radius:6px;border:1px solid #edf2fc;background-color:#edf2fc;transform:translateX(-50%);transition:opacity 0.3s,transform 0.5s,top 0.5s;}._msg p{margin:0;font-size:14px;padding-right:16px;}._msg svg{top:50%;right:15px;cursor:pointer;position:absolute;transform:translateY(-50%);}._msg-opacity{opacity:0;transform:translate(-50%,-100%);}._msg-success{background-color:#e1f3d8;border-color:#e1f3d8;color:#67c23a;}._msg-warn{background-color:#fdfce6;border-color:#fdfce6;color:#e6a23c;}._msg-error{background-color:#fef0f0;border-color:#fef0f0;color:#f56c6c;}";

var OPACITY = '_msg-opacity';
var instances = [];
var typeMap = ['info', 'success', 'warn', 'error'];
var style = createElement('style');
style.textContent = styles;
document.head.appendChild(style);
msg.zIndex = 1; // eslint-disable-next-line max-statements

function msg(options) {
  if (isString(options)) options = {
    text: options
  };

  var _Object$assign = Object.assign({
    type: typeMap[0],
    text: '',
    offset: 20,
    duration: 3e3
  }, options),
      text = _Object$assign.text,
      type = _Object$assign.type,
      zIndex = _Object$assign.zIndex,
      offset = _Object$assign.offset,
      duration = _Object$assign.duration,
      customClass = _Object$assign.customClass,
      html = _Object$assign.html,
      showClose = _Object$assign.showClose,
      onClose = _Object$assign.onClose,
      appendTo = _Object$assign.appendTo;

  var el = createElement('div', "_msg _msg-".concat(type, " ").concat(OPACITY, " ").concat(customClass || ''));
  el.id = unique();
  el._msg = {};
  el._msg.zIndex = zIndex || msg.zIndex;
  el._msg.offset = offset;
  instances.push(el); // 淡入

  setTimeout(function () {
    el.classList.remove(OPACITY);
  }, 100); // 持续时间大于0才会销毁，反之永不销毁
  // (可通过点击关闭按钮 或 调用destroyAll函数来销毁)

  if (duration) {
    el._msg.t = setTimeout(function () {
      destroy(el, onClose);
    }, duration); // 鼠标悬停取消销毁

    el.onmouseenter = function () {
      clearTimeout(el._msg.t);
    }; // 鼠标离开后，开始计时销毁


    el.onmouseleave = function () {
      el._msg.t = setTimeout(function () {
        destroy(el, onClose);
      }, duration);
    };
  }

  var p = createElement('p');
  el.appendChild(p);
  if (html) p.innerHTML = text;else p.innerText = text; // 是否显示关闭按钮

  if (showClose || !duration
  /* 如果持续时小于等于0，则强制显示关闭按钮 */
  ) {
    var closeSVG = createCloseSVG();

    closeSVG.onclick = function () {
      clearTimeout(el._msg.t);
      el.onmouseenter = el.onmouseleave = closeSVG.onclick = null;
      destroy(el, onClose);
    };

    el.appendChild(closeSVG);
  }

  var _appendTo;

  if (isElement(appendTo)) _appendTo = appendTo;else if (isString(appendTo)) _appendTo = document.querySelector(appendTo);
  if (!isElement(_appendTo)) _appendTo = document.body;

  _appendTo.appendChild(el);

  setPosition(instances);
}

var _loop = function _loop(i) {
  msg[typeMap[i]] = function (options) {
    if (isString(options)) {
      options = {
        text: options,
        type: typeMap[i]
      };
    } else {
      options.type = typeMap[i];
    }

    msg(options);
  };
};

for (var i in typeMap) {
  _loop(i);
}

msg.destroyAll = function () {
  var _loop2 = function _loop2(_i) {
    var el = instances[_i];
    clearTimeout(el._msg.t); // 等待淡出动画结束后删除

    el.classList.add(OPACITY);
    setTimeout(function () {
      el.parentElement.removeChild(el);
    }, 400);
  };

  for (var _i = 0; _i < instances.length; _i++) {
    _loop2(_i);
  }

  instances.length = 0;
};
/**
 * Destroy message
 * @param {Element} el Messages that need to be destroyed
 * @param {Function} onClose Before close callback function
 */


function destroy(el, onClose) {
  var index = instances.findIndex(function (_el) {
    return _el.id === el.id;
  });
  instances.splice(index, 1);
  setPosition(instances, index);
  if (typeof onClose === 'function') onClose(); // 等待淡出动画结束后删除

  el.classList.add(OPACITY);
  setTimeout(function () {
    el.parentElement.removeChild(el);
  }, 400);
}

export { msg as default };
